import React, { useEffect, useState } from "react";
import welcome from "../../assets/userman.png";
import { getBalance, getPaytronBalance } from "../../web3hooks/contracthooks";
import TransactionItems from "../transactionItems/transactionItems";
import "../../css/homepage.css";
import LineChart from "../graph/graph";

const AppTab = ({ values }) => {
  // transactions
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [depositAmount, setDepositAmount] = useState(0);
  const [PaytronBalance, setPaytronBalance] = useState(0);
  const [x, setX] = useState([]);
  const [y, setY] = useState([]);

  //-- graph--//
  const getGraph = () => {
    values?.transactions.map((item) => {
      setX((first) => [...first, item.date]);
      setY((first) => [...first, item.amount]);
    });
  };

  // deposit
  const deposit = async () => {
    const tronweb = window.tronWeb;
    const contract = await tronweb
      .contract()
      .at(process.env.REACT_APP_companyAddress);
    const amount = await tronweb.toSun(depositAmount);
    const hash = await contract.fundWallet(amount).send({
      feeLimit: 100_000_000,
      callValue: amount,
    });
    console.log(hash);
  };

  // get paytron balance and wallet balance
  const getBal = async () => {
    const tronWeb = window.tronWeb;
    const address = await tronWeb.trx.getAccount();
    const bal = await tronWeb.fromSun(address?.balance);
    const paytronBalance = await tronWeb.fromSun(
      await getPaytronBalance(address?.address)
    );
    setPaytronBalance(paytronBalance);
    setBalance(bal);
  };
  // useeffect
  useEffect(() => {
    setTransactions(values.transactions);
    getBal();
  }, []);

  useEffect(() => {
    getGraph();
  }, []);

  return (
    <div className="bg-gradient-br from-[#060409] to-[#361e42] px-2">
      <div className="lg:h-48 py-3 flex items-center w-full justify-start">
        <div className=" bg-transparent rounded-sm h-fit py-2 lg:w-2/5 items-start px-4 boxes">
          <div className="space-y-4">
            <div>
              <p className="text-3xl font-bold title">DASHBOARD</p>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:grid grid-cols-4 my-9 space-y-2 lg:space-y-0">
        <div className="mx-3 bg-gradient-to-r from-[#22f4fa]/60 to-[#060409] lg:h-24 py-3 flex flex-col justify-center space-y-2 px-4 rounded shadow-xl text-sm col-span-1 boxes">
          <p className=" font-medium text-white">Total Transactions</p>
          <p className="text-2xl font-semibold text-white">
            {transactions.length}
          </p>
        </div>
        <div className="mx-3 bg-gradient-to-r from-[#22f4fa]/60 to-[#060409] lg:h-24 py-3 flex flex-col justify-center space-y-2 px-4 rounded shadow-xl text-sm col-span-1 boxes">
          <p className=" font-medium text-white">Total Employees</p>
          <p className="text-2xl font-semibold text-white">
            {values?.employee?.length}
          </p>
        </div>
        <div className="mx-3 bg-gradient-to-r from-[#22f4fa]/60 to-[#060409] lg:h-24 py-3 flex flex-col justify-center space-y-2 px-4 rounded shadow-xl text-sm col-span-1 boxes">
          <p className=" font-medium text-white">Paytron Balance</p>
          <p className="text-2xl font-semibold text-white">
            {Number(PaytronBalance).toFixed(2)}TRX
          </p>
        </div>
        <div className="mx-3 bg-gradient-to-r from-[#22f4fa]/60 to-[#060409] lg:h-24 py-3 flex flex-col justify-center space-y-2 px-4 rounded shadow-xl text-sm col-span-1 boxes">
          <p className=" font-medium text-white">Wallet Balance</p>
          <p className="text-2xl font-semibold text-white">
            {Number(balance).toFixed(2)}TRX
          </p>
        </div>
      </div>
      <div className="lg:grid grid-cols-3 h-[60vh] px-4 my-6">
        <div className="bg-[#434242] rounded-md shadow-lg col-span-2 boxes pb-3">
          <div className="py-6 px-5">
            <p className="text-lg font-semibold text-white">Total Invoice</p>
          </div>
          <div className="grid grid-cols-6 px-5 py-2 text-[13px] text-white">
            <p className="lg:col-span-2 col-span-1">
              <span className="hidden lg:block">Transaction ID</span>
              <span className="lg:hidden">TXID</span>
            </p>
            <p className="lg:col-span-1 col-span-2">Employee</p>
            <p className="lg:col-span-1 col-span-2">Amount</p>
            <p className="col-span-1">Type</p>
            <p className="col-span-1 text-end pr-5">Status</p>
          </div>
          <>
            <div className=" overflow-y-scroll w-full h-[50vh] pb-3">
              <div>
                {transactions.map((item, i) => (
                  <TransactionItems transaction={item} key={i} />
                ))}
              </div>
            </div>
          </>
        </div>
        <div className="hidden col-span-1 ml-4 lg:flex flex-col justify-between">
          <div className="h-[45%] bg-[#434242] shadow-xl rounded-sm boxes">
            {x != "" && <LineChart labels={x} data={y} />}
          </div>
          <div className="h-[45%] bg-slate-100 shadow-2xl rounded-sm boxes">
            <div className="text-white bg-[#434242] h-full flex flex-1 items-center py-4 space-y-3 flex-col px-4">
              <label className=" font-Varela">Amount to deposit</label>
              <input
                id="deposit"
                type="number"
                className="py-2 w-full p-2 text-[13px] bg-white/60 text-black"
                name="deposit"
                value={depositAmount}
                onChange={(e) => setDepositAmount(e.target.value)}
                placeholder="amount to be deposited"
                required
              />
              <button
                className="text-xs bg-green-600 px-3 py-2 rounded-sm"
                onClick={deposit}
              >
                Deposit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="h-[40vh] flex items-center justify-center">
        <p className="text-2xl font-semibold text-center">Coming soon...</p>
      </div>
    </div>
  );
};

export default AppTab;
